// Tipos de valor de uma condição que o RegraCampoIntegracaoEvaluator da API
// interpreta: "static" compara com o texto digitado e "campo" compara com o
// valor de outro campo da Verso. A API exige o tipo em toda condição que
// compara com valor.
export const TIPOS_VALOR_CONDICAO = [
  { value: "static", label: "Valor fixo" },
  { value: "campo", label: "Outro campo" },
];

// "é nulo" e "não é nulo" não comparam com valor; o tipo não se aplica.
const OPERADORES_SEM_VALOR = ["nulo", "nao_nulo"];

export function operadorSemValor(operador) {
  return OPERADORES_SEM_VALOR.includes(operador);
}

export function exigeTipoValor(cond) {
  return !!cond && !operadorSemValor(cond.operador);
}

export function tipoValorConhecido(tipo) {
  return TIPOS_VALOR_CONDICAO.some((t) => t.value === tipo);
}

// Inclui o valor gravado na lista quando ele não está no catálogo, para o
// select não aparecer vazio e o usuário enxergar o que está configurado.
export function opcoesComValorAtual(campos, valorAtual) {
  const lista = campos || [];
  if (typeof valorAtual !== "string" || !valorAtual) return lista;
  if (lista.some((c) => c.value === valorAtual)) return lista;
  return [{ value: valorAtual, label: `${valorAtual} (fora da lista)` }, ...lista];
}

// Posições (base 1) das condições sem tipo de valor, por regra.
export function condicoesSemTipoValor(regra) {
  const pendentes = [];
  ((regra && regra.casos) || []).forEach((caso, ci) => {
    let posicao = 0;
    ((caso && caso.condicao && caso.condicao.grupos) || []).forEach((grupo) => {
      ((grupo && grupo.condicoes) || []).forEach((cond) => {
        posicao += 1;
        if (exigeTipoValor(cond) && !cond.tipo_valor) {
          pendentes.push({ regra: ci + 1, condicao: posicao });
        }
      });
    });
  });
  return pendentes;
}
